module.exports = __webpack_public_path__ + "img/项目场景_日常管理.cbe8a519.jpg";